import React, { PureComponent } from 'react';
import { uniqueId } from 'lodash';
import { parsePrice } from '../../../../../../lib/helper.js';
import OrderModifiers from './OrderModifiers';

class OrderHistoryBody extends PureComponent {
  render() {
    const { items=[] } = this.props;

    return (
      <ul className="list-style olo-client-theme-color ">
      {items.map( (itemData, key) => (
        <div className="item" key={uniqueId('prices-details-')}>
          <li key={key}>
            <div className="forced-modifers-body">
              <div className="forced-modifers-name">{itemData.name}</div>
              <span className="forced-modifers-description-prices">
                {parsePrice(itemData.price)}
              </span>
            </div>
          </li>
          {itemData.notes ? <li className="break ">{`** ${itemData.notes}`}</li> : null}
          <OrderModifiers modifiers={itemData.modifiers} />
          <hr className="order-items-separator" />
        </div>
      ))}
      </ul>
    );
  }
}

export default OrderHistoryBody;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/OrderItems.jsx